// extracted by mini-css-extract-plugin
module.exports = {"containerImg":"styles_containerImg__2WR5J"};